import React from 'react';
import { Button, useMobile } from '@octano/global-ui';

export type QuestionProgressProps = {
  current: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
  disabledNext?: boolean;
};

const QuestionProgress: React.FC<QuestionProgressProps> = ({
  current,
  total,
  onPrev,
  onNext,
  disabledNext = false,
}) => {
  const isMobile = useMobile();

  const containerStyle = isMobile
    ? {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        padding: '0 20px',
      }
    : {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      };

  return (
    <div style={containerStyle}>
      <Button
        icon="chevron_left"
        outlined
        disabled={current === 1}
        onClick={onPrev}
        size="sm"
        style={
          isMobile
            ? { paddingRight: 8 }
            : {
                margin: '0 50px',
                paddingRight: 10,
              }
        }
      />
      <span
        style={{
          textAlign: 'center',
          fontSize: 16,
          color: 'var(--primary)',
        }}
      >
        {current} / {total}
      </span>
      <Button
        icon="chevron_right"
        outlined
        disabled={disabledNext}
        onClick={onNext}
        size="sm"
        style={
          isMobile
            ? { paddingRight: 8 }
            : {
                margin: '0 50px',
                paddingRight: 8,
                paddingLeft: 17,
              }
        }
      />
    </div>
  );
};

export default QuestionProgress;
